import React, { useRef, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Button,
  Alert,
  CircularProgress,
} from '@mui/material';
import { useSelector } from 'react-redux';
import AdminUserDetail from '../../utilities/api/user/AdminUserDetail';

import MBFLogo from '../../utilities/dummy_assets/MBF_Logo.png';
import MapITLogo from '../../utilities/dummy_assets/mapITlogo.png';
import background from '../../utilities/dummy_assets/background.png';
import Logo from '../../utilities/dummy_assets/MBF_Logo.png';
import tinkerersLogo from '../../utilities/dummy_assets/tinkerersLogo.png';
import mapITlogo from '../../utilities/dummy_assets/mapITlogo.png';

const ProfileResubmit = () => {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [imageData, setImageData] = useState(null);
  const [stream, setStream] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const navigate = useNavigate();
  //   const user = useSelector((state) => state.auth.user);

  useEffect(() => {
    startCamera();
    return stopCamera;
  }, []);

  const startCamera = async () => {
    try {
      const currentStream = await navigator.mediaDevices.getUserMedia({
        video: true,
      });
      if (videoRef.current) {
        videoRef.current.srcObject = currentStream;
      }
      setStream(currentStream);
    } catch (err) {
      console.error('Error accessing webcam:', err);
    }
  };

  const stopCamera = () => {
    if (stream) {
      stream.getTracks().forEach(track => track.stop());
    }
  };

  const captureImage = () => {
    const video = videoRef.current;
    const canvas = canvasRef.current;
    if (!video || !canvas) return;

    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;

    const context = canvas.getContext('2d');
    context.drawImage(video, 0, 0, canvas.width, canvas.height);

    const dataUrl = canvas.toDataURL('image/png');
    setImageData(dataUrl);
    stopCamera();
  };

  const handleRetake = () => {
    setImageData(null);
    startCamera();
  };

  const handleUpload = async () => {
    if (!imageData) {
      setErrorMessage('No image captured or user not found');
      return;
    }

    setUploading(true);
    setErrorMessage('');

    try {
      // Convert base64 to blob
      const response = await fetch(imageData);
      const blob = await response.blob();

      // Create FormData and append the image
      const formData = new FormData();
      formData.append('profile_pic', blob, 'profile_image.png');

      // Call the API to update user profile
      const apiResponse =
        await AdminUserDetail.AdminDetailAddFRTImage(formData);

      // Show success message
      setSuccessMessage('Profile image uploaded successfully!');

      // Navigate to dashboard after a short delay
      setTimeout(() => {
        navigate('/dashboard');
      }, 200);
    } catch (error) {
      console.error('Error uploading image:', error);
      setErrorMessage('Failed to upload image. Please try again.');
    } finally {
      setUploading(false);
    }
  };
  return (
    <Box
      sx={{
        width: '100vw',
        height: '100vh',
        overflow: 'hidden',
        display: 'flex',
        // justifyContent: "center",
        alignItems: 'center',
        backgroundImage: `url(${background})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        position: 'relative',
        // padding: "1rem",
        boxSizing: 'border-box',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <Box sx={{ position: 'absolute', top: 20, right: 20 }}>
        <Typography
          component="a"
          href="/student"
          sx={{
            textDecoration: 'underline',
            color: '#007BFF',
            fontWeight: 500,
            fontSize: '16px',
          }}
        >
          Go to student site
        </Typography>
      </Box>

      {/* Main Capture UI */}
      <Box
        sx={{
          backgroundColor: 'white',
          borderRadius: '20px',
          padding: '24px',
          width: '100%',
          maxWidth: '700px',
          boxShadow: '4px 4px 20px rgba(0, 123, 255, 0.1)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '16px',
          margin: 'auto',
        }}
      >
        <Typography variant="h6" fontWeight={600} color="#212121">
          Set Your Profile Photo
        </Typography>

        {!imageData ? (
          <>
            <video
              ref={videoRef}
              autoPlay
              playsInline
              style={{
                width: '100%',
                borderRadius: '12px',
                border: '2px solid #ccc',
              }}
            />
            <Button
              onClick={captureImage}
              variant="contained"
              sx={{
                backgroundColor: '#007BFF',
                borderRadius: '10px',
                padding: '10px 20px',
                fontWeight: 600,
                textTransform: 'none',
              }}
            >
              Capture
            </Button>
            <a href="/register-instructions">Back</a>
          </>
        ) : (
          <>
            <img
              src={imageData}
              alt="Captured"
              style={{
                width: '500px',
                height: '500px',
                objectFit: 'cover',
                borderRadius: '12px',
                border: '1px solid #888',
              }}
            />
            {errorMessage && (
              <Alert severity="error" sx={{ width: '100%', mb: 2 }}>
                {errorMessage}
              </Alert>
            )}
            {successMessage && (
              <Alert severity="success" sx={{ width: '100%', mb: 2 }}>
                {successMessage}
              </Alert>
            )}
            <Box sx={{ display: 'flex', gap: '1rem' }}>
              <Button
                onClick={handleRetake}
                variant="outlined"
                disabled={uploading}
                sx={{
                  borderRadius: '10px',
                  padding: '8px 20px',
                  textTransform: 'none',
                }}
              >
                Take Again
              </Button>
              <Button
                onClick={handleUpload}
                variant="contained"
                disabled={uploading}
                sx={{
                  backgroundColor: '#007BFF',
                  borderRadius: '10px',
                  padding: '8px 20px',
                  color: '#fff',
                  fontWeight: 600,
                  textTransform: 'none',
                }}
              >
                {uploading ? (
                  <>
                    <CircularProgress
                      size={16}
                      sx={{ color: 'white', mr: 1 }}
                    />
                    Uploading...
                  </>
                ) : (
                  'Upload'
                )}
              </Button>
            </Box>
          </>
        )}
        <canvas ref={canvasRef} style={{ display: 'none' }} />
      </Box>

      {/* Footer */}
      <Box
        sx={{
          justifyContent: 'center',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center', // Adjust alignment to center
          p: '16px 24px',
          mt: 'auto', // Push the footer to the bottom
          gap: '1rem', // Add consistent spacing between elements
        }}
      >
        <img
          src={Logo}
          alt="MBF Logo"
          style={{ height: '60px', width: '150px' }}
        />
        <img
          src={tinkerersLogo}
          alt="mapIT Logo"
          style={{ height: '60px', width: '150px' }}
        />
        <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: '0.5rem' }}>
          <img
            src={mapITlogo}
            alt="mapIT Logo"
            style={{ height: '60px', width: '60px' }}
          />
          <Typography
            sx={{
              color: '#4b0282',
              fontFamily: "'Arial Black', 'Helvetica Neue', Arial, sans-serif",
              fontSize: '28px',
              fontWeight: 900,
              lineHeight: '1',
              letterSpacing: '-0.02rem',
              margin: 0,
              whiteSpace: 'nowrap',
              textTransform: 'none',
              fontStyle: 'normal',
              marginLeft: '-0.5rem',
            }}
          >
            apIT.ai
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ProfileResubmit;
